/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  BusinessReportDataResponseModel,
  CustomerStatsFilter,
  Forbidden,
  InternalServerError,
  ManagerReportOfBonusCustomersResponseModel,
  ManagerReportOfDevicesConfigurationsResponseModel,
  ManagerReportOfUserActivityResponseModel,
  NotFound,
  Unauthorized,
} from '../models';

export interface CrmCustomersBusinessReportsDownloadHomeComfortBonusReportRequest {
    fileName: string;
}

export interface CrmCustomersBusinessReportsGetCreationReportsRequest {
    aggregation: string;
    fromDate: string;
    toDate: string;
    filters?: CustomerStatsFilter;
}

export interface CrmCustomersBusinessReportsGetCreationReportsIncrementalRequest {
    aggregation: string;
    fromDate: string;
    toDate: string;
    filters?: CustomerStatsFilter;
}

export interface CrmCustomersBusinessReportsGetProductReportsRequest {
    aggregation: string;
    fromDate: string;
    toDate: string;
}

export interface CrmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStatesRequest {
    aggregation: string;
    fromDate: string;
    toDate: string;
    states: string;
}

export interface CrmCustomersBusinessReportsGetStatusReportsRequest {
    aggregation: string;
    fromDate: string;
    toDate: string;
}

export interface CrmCustomersBusinessReportsGetTenantReportsRequest {
    aggregation: string;
    fromDate: string;
    toDate: string;
}

export interface CrmCustomersBusinessReportsGetVendorReportsRequest {
    aggregation: string;
    fromDate: string;
    toDate: string;
}

export interface CrmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStatesRequest {
    aggregation: string;
    fromDate: string;
    toDate: string;
    states: string;
}

/**
 * 
 */
export class CRMCustomersBusinessReportsApi extends runtime.BaseAPI {

    /**
     * Downloads a specific CSV report file for Home & Comfort bonus program customers. Use the list endpoint to discover available file names before downloading
     * Download Home & Comfort Bonus Report File
     */
    async crmCustomersBusinessReportsDownloadHomeComfortBonusReportRaw(requestParameters: CrmCustomersBusinessReportsDownloadHomeComfortBonusReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName','Required parameter requestParameters.fileName was null or undefined when calling crmCustomersBusinessReportsDownloadHomeComfortBonusReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/home-comfort/{fileName}`.replace(`{${"fileName"}}`, encodeURIComponent(String(requestParameters.fileName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Downloads a specific CSV report file for Home & Comfort bonus program customers. Use the list endpoint to discover available file names before downloading
     * Download Home & Comfort Bonus Report File
     */
    async crmCustomersBusinessReportsDownloadHomeComfortBonusReport(requestParameters: CrmCustomersBusinessReportsDownloadHomeComfortBonusReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.crmCustomersBusinessReportsDownloadHomeComfortBonusReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves metrics about when customers were created, showing signup trends and growth patterns. Supports additional filtering by customer attributes for segmented analysis
     * Get Customer Creation Date Reports
     */
    async crmCustomersBusinessReportsGetCreationReportsRaw(requestParameters: CrmCustomersBusinessReportsGetCreationReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportDataResponseModel>> {
        if (requestParameters.aggregation === null || requestParameters.aggregation === undefined) {
            throw new runtime.RequiredError('aggregation','Required parameter requestParameters.aggregation was null or undefined when calling crmCustomersBusinessReportsGetCreationReports.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling crmCustomersBusinessReportsGetCreationReports.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling crmCustomersBusinessReportsGetCreationReports.');
        }

        const queryParameters: any = {};

        if (requestParameters.filters !== undefined) {
            queryParameters['filters'] = requestParameters.filters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/creation/{aggregation}/{fromDate}/{toDate}`.replace(`{${"aggregation"}}`, encodeURIComponent(String(requestParameters.aggregation))).replace(`{${"fromDate"}}`, encodeURIComponent(String(requestParameters.fromDate))).replace(`{${"toDate"}}`, encodeURIComponent(String(requestParameters.toDate))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves metrics about when customers were created, showing signup trends and growth patterns. Supports additional filtering by customer attributes for segmented analysis
     * Get Customer Creation Date Reports
     */
    async crmCustomersBusinessReportsGetCreationReports(requestParameters: CrmCustomersBusinessReportsGetCreationReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportDataResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetCreationReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves cumulative customer creation metrics showing total customer count growth over time. Each data point represents the running total of customers created up to that point
     * Get Incremental Customer Creation Reports
     */
    async crmCustomersBusinessReportsGetCreationReportsIncrementalRaw(requestParameters: CrmCustomersBusinessReportsGetCreationReportsIncrementalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportDataResponseModel>> {
        if (requestParameters.aggregation === null || requestParameters.aggregation === undefined) {
            throw new runtime.RequiredError('aggregation','Required parameter requestParameters.aggregation was null or undefined when calling crmCustomersBusinessReportsGetCreationReportsIncremental.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling crmCustomersBusinessReportsGetCreationReportsIncremental.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling crmCustomersBusinessReportsGetCreationReportsIncremental.');
        }

        const queryParameters: any = {};

        if (requestParameters.filters !== undefined) {
            queryParameters['filters'] = requestParameters.filters;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/creation/{aggregation}/{fromDate}/{toDate}/incremental`.replace(`{${"aggregation"}}`, encodeURIComponent(String(requestParameters.aggregation))).replace(`{${"fromDate"}}`, encodeURIComponent(String(requestParameters.fromDate))).replace(`{${"toDate"}}`, encodeURIComponent(String(requestParameters.toDate))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves cumulative customer creation metrics showing total customer count growth over time. Each data point represents the running total of customers created up to that point
     * Get Incremental Customer Creation Reports
     */
    async crmCustomersBusinessReportsGetCreationReportsIncremental(requestParameters: CrmCustomersBusinessReportsGetCreationReportsIncrementalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportDataResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetCreationReportsIncrementalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of all available report endpoint paths. Use this as a discovery endpoint to understand available reporting capabilities
     * Get Available Report Endpoints
     */
    async crmCustomersBusinessReportsGetEndpointsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns a list of all available report endpoint paths. Use this as a discovery endpoint to understand available reporting capabilities
     * Get Available Report Endpoints
     */
    async crmCustomersBusinessReportsGetEndpoints(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.crmCustomersBusinessReportsGetEndpointsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Generates and downloads a CSV report containing all E.ON Home and Drive customers with BMW and Mini vehicle integrations. Includes customer details and vehicle-specific data
     * Download E.ON Home and Drive BMW/Mini Customers Report
     */
    async crmCustomersBusinessReportsGetEonHomeAndDriveBmwAndMiniReportRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/eonHomeAndDriveBmwAndMini`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Generates and downloads a CSV report containing all E.ON Home and Drive customers with BMW and Mini vehicle integrations. Includes customer details and vehicle-specific data
     * Download E.ON Home and Drive BMW/Mini Customers Report
     */
    async crmCustomersBusinessReportsGetEonHomeAndDriveBmwAndMiniReport(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.crmCustomersBusinessReportsGetEonHomeAndDriveBmwAndMiniReportRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of all available CSV reports for Home & Comfort bonus program customers. Returns file names and metadata for downloadable reports
     * List Available Home & Comfort Bonus Reports
     */
    async crmCustomersBusinessReportsGetHomeComfortBonusReportsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManagerReportOfBonusCustomersResponseModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/home-comfort`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a list of all available CSV reports for Home & Comfort bonus program customers. Returns file names and metadata for downloadable reports
     * List Available Home & Comfort Bonus Reports
     */
    async crmCustomersBusinessReportsGetHomeComfortBonusReports(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManagerReportOfBonusCustomersResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetHomeComfortBonusReportsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Generates and downloads a comprehensive JSON report of all device configurations including hardware details, settings, and installation information. File is returned as a downloadable attachment
     * Download Device Configurations Report
     */
    async crmCustomersBusinessReportsGetManagerReportDevicesConfigurationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ManagerReportOfDevicesConfigurationsResponseModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/devicesConfigurations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Generates and downloads a comprehensive JSON report of all device configurations including hardware details, settings, and installation information. File is returned as a downloadable attachment
     * Download Device Configurations Report
     */
    async crmCustomersBusinessReportsGetManagerReportDevicesConfigurations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ManagerReportOfDevicesConfigurationsResponseModel>> {
        const response = await this.crmCustomersBusinessReportsGetManagerReportDevicesConfigurationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Generates and downloads a comprehensive JSON report of user activity including login history, feature usage, and engagement metrics. File is returned as a downloadable attachment
     * Download User Activity Report
     */
    async crmCustomersBusinessReportsGetManagerReportUsersActivityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ManagerReportOfUserActivityResponseModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/usersActivities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Generates and downloads a comprehensive JSON report of user activity including login history, feature usage, and engagement metrics. File is returned as a downloadable attachment
     * Download User Activity Report
     */
    async crmCustomersBusinessReportsGetManagerReportUsersActivity(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ManagerReportOfUserActivityResponseModel>> {
        const response = await this.crmCustomersBusinessReportsGetManagerReportUsersActivityRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves installation and product-specific metrics aggregated over time. Supports filtering by customer states (active, inactive, deleted) to analyze different customer segments
     * Get Product Installation Reports
     */
    async crmCustomersBusinessReportsGetProductReportsRaw(requestParameters: CrmCustomersBusinessReportsGetProductReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportDataResponseModel>> {
        if (requestParameters.aggregation === null || requestParameters.aggregation === undefined) {
            throw new runtime.RequiredError('aggregation','Required parameter requestParameters.aggregation was null or undefined when calling crmCustomersBusinessReportsGetProductReports.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling crmCustomersBusinessReportsGetProductReports.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling crmCustomersBusinessReportsGetProductReports.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/product/{aggregation}/{fromDate}/{toDate}`.replace(`{${"aggregation"}}`, encodeURIComponent(String(requestParameters.aggregation))).replace(`{${"fromDate"}}`, encodeURIComponent(String(requestParameters.fromDate))).replace(`{${"toDate"}}`, encodeURIComponent(String(requestParameters.toDate))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves installation and product-specific metrics aggregated over time. Supports filtering by customer states (active, inactive, deleted) to analyze different customer segments
     * Get Product Installation Reports
     */
    async crmCustomersBusinessReportsGetProductReports(requestParameters: CrmCustomersBusinessReportsGetProductReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportDataResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetProductReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves installation and product-specific metrics aggregated over time. Supports filtering by customer states (active, inactive, deleted) to analyze different customer segments
     * Get Product Installation Reports
     */
    async crmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStatesRaw(requestParameters: CrmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportDataResponseModel>> {
        if (requestParameters.aggregation === null || requestParameters.aggregation === undefined) {
            throw new runtime.RequiredError('aggregation','Required parameter requestParameters.aggregation was null or undefined when calling crmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStates.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling crmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStates.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling crmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStates.');
        }

        if (requestParameters.states === null || requestParameters.states === undefined) {
            throw new runtime.RequiredError('states','Required parameter requestParameters.states was null or undefined when calling crmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/product/{aggregation}/{fromDate}/{toDate}/{states}`.replace(`{${"aggregation"}}`, encodeURIComponent(String(requestParameters.aggregation))).replace(`{${"fromDate"}}`, encodeURIComponent(String(requestParameters.fromDate))).replace(`{${"toDate"}}`, encodeURIComponent(String(requestParameters.toDate))).replace(`{${"states"}}`, encodeURIComponent(String(requestParameters.states))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves installation and product-specific metrics aggregated over time. Supports filtering by customer states (active, inactive, deleted) to analyze different customer segments
     * Get Product Installation Reports
     */
    async crmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStates(requestParameters: CrmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportDataResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetProductReportsByAggregationFromDateToDateStatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves customer identity and access management (CIAM) status metrics including login activity, account verification status, and user engagement patterns over time
     * Get Customer Status and Activity Reports
     */
    async crmCustomersBusinessReportsGetStatusReportsRaw(requestParameters: CrmCustomersBusinessReportsGetStatusReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportDataResponseModel>> {
        if (requestParameters.aggregation === null || requestParameters.aggregation === undefined) {
            throw new runtime.RequiredError('aggregation','Required parameter requestParameters.aggregation was null or undefined when calling crmCustomersBusinessReportsGetStatusReports.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling crmCustomersBusinessReportsGetStatusReports.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling crmCustomersBusinessReportsGetStatusReports.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/status/{aggregation}/{fromDate}/{toDate}`.replace(`{${"aggregation"}}`, encodeURIComponent(String(requestParameters.aggregation))).replace(`{${"fromDate"}}`, encodeURIComponent(String(requestParameters.fromDate))).replace(`{${"toDate"}}`, encodeURIComponent(String(requestParameters.toDate))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves customer identity and access management (CIAM) status metrics including login activity, account verification status, and user engagement patterns over time
     * Get Customer Status and Activity Reports
     */
    async crmCustomersBusinessReportsGetStatusReports(requestParameters: CrmCustomersBusinessReportsGetStatusReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportDataResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetStatusReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves country and region-specific key performance indicators for customers. Data is aggregated by the specified time period and includes geographic distribution metrics
     * Get Tenant-Based Customer KPIs
     */
    async crmCustomersBusinessReportsGetTenantReportsRaw(requestParameters: CrmCustomersBusinessReportsGetTenantReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportDataResponseModel>> {
        if (requestParameters.aggregation === null || requestParameters.aggregation === undefined) {
            throw new runtime.RequiredError('aggregation','Required parameter requestParameters.aggregation was null or undefined when calling crmCustomersBusinessReportsGetTenantReports.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling crmCustomersBusinessReportsGetTenantReports.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling crmCustomersBusinessReportsGetTenantReports.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/tenant/{aggregation}/{fromDate}/{toDate}`.replace(`{${"aggregation"}}`, encodeURIComponent(String(requestParameters.aggregation))).replace(`{${"fromDate"}}`, encodeURIComponent(String(requestParameters.fromDate))).replace(`{${"toDate"}}`, encodeURIComponent(String(requestParameters.toDate))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves country and region-specific key performance indicators for customers. Data is aggregated by the specified time period and includes geographic distribution metrics
     * Get Tenant-Based Customer KPIs
     */
    async crmCustomersBusinessReportsGetTenantReports(requestParameters: CrmCustomersBusinessReportsGetTenantReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportDataResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetTenantReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves vendor-related key performance indicators including device manufacturer distributions, hardware metrics, and vendor-specific customer segments. Supports filtering by customer states
     * Get Vendor-Specific Customer KPIs
     */
    async crmCustomersBusinessReportsGetVendorReportsRaw(requestParameters: CrmCustomersBusinessReportsGetVendorReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportDataResponseModel>> {
        if (requestParameters.aggregation === null || requestParameters.aggregation === undefined) {
            throw new runtime.RequiredError('aggregation','Required parameter requestParameters.aggregation was null or undefined when calling crmCustomersBusinessReportsGetVendorReports.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling crmCustomersBusinessReportsGetVendorReports.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling crmCustomersBusinessReportsGetVendorReports.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/vendor/{aggregation}/{fromDate}/{toDate}`.replace(`{${"aggregation"}}`, encodeURIComponent(String(requestParameters.aggregation))).replace(`{${"fromDate"}}`, encodeURIComponent(String(requestParameters.fromDate))).replace(`{${"toDate"}}`, encodeURIComponent(String(requestParameters.toDate))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves vendor-related key performance indicators including device manufacturer distributions, hardware metrics, and vendor-specific customer segments. Supports filtering by customer states
     * Get Vendor-Specific Customer KPIs
     */
    async crmCustomersBusinessReportsGetVendorReports(requestParameters: CrmCustomersBusinessReportsGetVendorReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportDataResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetVendorReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves vendor-related key performance indicators including device manufacturer distributions, hardware metrics, and vendor-specific customer segments. Supports filtering by customer states
     * Get Vendor-Specific Customer KPIs
     */
    async crmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStatesRaw(requestParameters: CrmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessReportDataResponseModel>> {
        if (requestParameters.aggregation === null || requestParameters.aggregation === undefined) {
            throw new runtime.RequiredError('aggregation','Required parameter requestParameters.aggregation was null or undefined when calling crmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStates.');
        }

        if (requestParameters.fromDate === null || requestParameters.fromDate === undefined) {
            throw new runtime.RequiredError('fromDate','Required parameter requestParameters.fromDate was null or undefined when calling crmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStates.');
        }

        if (requestParameters.toDate === null || requestParameters.toDate === undefined) {
            throw new runtime.RequiredError('toDate','Required parameter requestParameters.toDate was null or undefined when calling crmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStates.');
        }

        if (requestParameters.states === null || requestParameters.states === undefined) {
            throw new runtime.RequiredError('states','Required parameter requestParameters.states was null or undefined when calling crmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/reports/vendor/{aggregation}/{fromDate}/{toDate}/{states}`.replace(`{${"aggregation"}}`, encodeURIComponent(String(requestParameters.aggregation))).replace(`{${"fromDate"}}`, encodeURIComponent(String(requestParameters.fromDate))).replace(`{${"toDate"}}`, encodeURIComponent(String(requestParameters.toDate))).replace(`{${"states"}}`, encodeURIComponent(String(requestParameters.states))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves vendor-related key performance indicators including device manufacturer distributions, hardware metrics, and vendor-specific customer segments. Supports filtering by customer states
     * Get Vendor-Specific Customer KPIs
     */
    async crmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStates(requestParameters: CrmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessReportDataResponseModel> {
        const response = await this.crmCustomersBusinessReportsGetVendorReportsByAggregationFromDateToDateStatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
